export const POLICY_EFFECTIVE_DATE = "7 July 2026";

export const CONTACT = {
  email: "oorilabel@gmail.com",
  whatsapp: "+91 8169098374",
  whatsappHref: "https://wa.me/918169098374",
  website: "www.oorilabel.com",
};

export const LEGAL = {
  entity: "OORI Label",
  registeredOffice: "Mumbai, Maharashtra, India",
  grievanceOfficer: "Grievance Officer",
  jurisdictionCity: "Mumbai",
};

export const POLICY_NAV = [
  { slug: "terms", title: "Terms of Service" },
  { slug: "privacy", title: "Privacy Policy" },
  { slug: "shipping", title: "Shipping Policy" },
  { slug: "returns", title: "Exchange & Returns" },
  { slug: "contact", title: "Help & Contact" },
];

export function policyPath(slug) {
  return slug ? `/policies/${slug}` : "/policies";
}
